<template>
    <div>
        <base-modal id="modalContact">
            <div class="modal-header">
                <user-picture :size="'-medium'" :border="'-border-light'" :user="user" v-if="user" />

                <h2 class="title">Encontrar meu <span class="color-alt">Novo imóvel</span></h2>
                <p class="subtitle">Informe os seus dados e os dados do imóvel ideal para você</p>
                <i class="far fa-city icon" aria-hidden="true"></i>
            </div>
            <div class="modal-body text-left">
                <slot />

                <form class="form" @submit.prevent="submit" novalidate>
                    <div class="input-group">
                        <input
                            class="input -xlarge"
                            type="text"
                            v-model.trim="$v.name.$model"
                            :class="{ '-error': $v.name.$error }"
                            placeholder="Qual seu nome?"
                        />
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.name.required">O campo <strong>Nome</strong> é obrigatório.</p>
                    </div>
                    <div class="input-group">
                        <input
                            class="input -xlarge"
                            type="tel"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            v-model.trim="$v.phone.$model"
                            :class="{ '-error': $v.phone.$error }"
                            placeholder="Qual seu telefone?"
                        />
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.phone.required">O campo <strong>Telefone</strong> é obrigatório.</p>
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.phone.minLength">O campo <strong>Telefone</strong> deve ser um telefone válido.</p>
                    </div>
                    <div class="input-group">
                        <input
                            class="input -xlarge"
                            type="email"
                            required="false"
                            v-model.trim="$v.email.$model"
                            :class="{ '-error': $v.email.$error }"
                            placeholder="Qual seu e-mail?"
                        />
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.email.required">O campo <strong>E-mail</strong> é obrigatório.</p>
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.email.email">O campo <strong>E-mail</strong> deve ser um e-mail válido.</p>
                    </div>
                    <div class="input-group">
                        <textarea
                            class="input -xlarge"
                            type="text"
                            v-model.trim="$v.message.$model"
                            :class="{ '-error': $v.message.$error }"
                            placeholder="Preciso de um apartamento de 3 quartos com 2 suíte  no Setor Bueno ou Setor Marista de preferência com 2 vagas  de garagem no valor de até R$ 9550.000.00"
                        >
                        </textarea>
                        <p class="alert -error" v-if="submitStatus == 'ERROR' && !$v.message.required">O campo <strong>Mensagem</strong> é obrigatório.</p>
                    </div>
                    <div class="actions text-center">
                        <button class="button -block -xlarge -contrast">
                            Enviar
                            <i class="fad fa-circle-notch fa-spin" v-if="submitStatus == 'PENDING'"></i>
                        </button>
                    </div>
                </form>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from '@/Components/BaseModal'
    import UserPicture from '@/Components/User/UserPicture'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    export default {
        components: {
            BaseModal,
            UserPicture,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {
                name: '',
                phone: '',
                email: '',
                message: '',
                notificationType: 'E-mail',
                submitStatus: null,
            }
        },

        computed: {},

        methods: {
            close() {
                this.reset()
                this.$root.$emit('hideModal', 'modalContact')
            },

            submit() {
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.submitStatus = 'ERROR'
                } else {
                    this.submitStatus = 'PENDING'

                    setTimeout(() => {
                        this.submitStatus = 'OK'
                        this.notification()
                    }, 1000)
                }
            },

            reset() {
                this.name = ''
                this.phone = ''
                this.email = ''
                this.message = ''
                this.$v.$reset()
            },

            notification() {
                this.$root.$emit('showModal', 'modalContactNotification')
                this.$root.$emit('notification', { ...this.$data })
                this.close()
            },
        },

        destroyed() {
            this.close()
        },

        validations: {
            name: {
                required,
            },
            phone: {
                required,
                minLength: minLength(14)
            },
            email: {
                required,
                email,
            },
            message: {
                required,
            },
        },
    }
</script>

<style lang="stylus" scoped></style>